export class WebToolItem {
  name = '';
  description = '';
  homeUrl = '';
  imageSource = '';
  expired = false;
  licensed = false;
  showLearnMore = false;

  constructor(item: {
    name: string;
    description: string;
    homeUrl: string;
    imageSource: string;
    expired: boolean;
    licensed: boolean;
  }) {
    this.name = item.name.replace(/^ALK /, '').replace(/^CoPilot /, '');
    this.description = item.description;
    this.homeUrl = item.homeUrl;
    this.imageSource = `/assets/img/${item.imageSource}`;
    this.expired = item.expired;
    this.licensed = item.licensed;
  }
}
